import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { SearchItem } from 'src/app/models/searchItem';
import { ContextualHelpService } from 'src/app/services/contextualHelpService';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { SearchService } from 'src/app/services/search.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-search-control',
  templateUrl: './search-control.component.html',
  styleUrls: ['./search-control.component.scss'],
  standalone: false
})
export class SearchControlComponent {

  keyword = 'name';
  options : SearchItem[] = [];
  selectedSearchItem: SearchItem; //only used for items that open file explorer
  @ViewChild('fileElement',{static:true}) fileInput : ElementRef<HTMLInputElement>;
  constructor(public searchService: SearchService, public menuService: MenuManagementService,
    private utilsService : UtilsService,public contextHelpService: ContextualHelpService,
    public modalMessage: ModalControlService) {
    this.options = searchService.searchItems;
   }

  selectEvent(item) {
    // TODO: Best way to do this whitout using a foreach
    this.options.forEach( searchItem => {
      if(searchItem.name == item.name) {
        if(this.contextHelpService.isMenuOptionEnabled(item.name)){

          if(searchItem.opensFileExplorer){
            this.selectedSearchItem = searchItem;
            this.fileInput.nativeElement.value='';
            this.fileInput.nativeElement.click();
          }
          else{
            searchItem.action();
          }
        }
        else{
          this.modalMessage.showMesssageModal("Error", ContextualHelpService.UNAVAILABLE_OPTION);
        }
        return;
      }
    })
  }
  fileExplorerCallBack(file:any){
    this.selectedSearchItem.action(file);
    this.selectedSearchItem = null;
  }
  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e){
    // do something when input is focused
  }
  test(data:any){

  }
  expandSearch(){
    if(!this.searchService.expanded){
      this.searchService.expanded = !this.searchService.expanded;
      this.menuService.open = false;
      this.menuService.closeAllMenus();
    }
  }

}
